export default "__VITE_ASSET__B11xb5hv__"